import type { PivotLayout, PivotLayoutFilter } from '@ztechapps/common.contract'
import { describePivotValueFilter, findPivotValueFilterProblem } from '@ztechapps/common.utils'

/** A Top / Bottom N in the filter bar — its filters entry and its wording. */
export type PivotValueFilterChip = { filter: PivotLayoutFilter; label: string }

/** Lists the filters entries holding a valid Top / Bottom N, each with its wording. */
export const listPivotValueFilterChips = (
  layout: Pick<PivotLayout, 'rows' | 'columns' | 'measures' | 'filters'>
): PivotValueFilterChip[] =>
  layout.filters.flatMap((filter) =>
    filter.valueFilter === undefined || findPivotValueFilterProblem(layout, filter) !== undefined
      ? []
      : [{ filter, label: describePivotValueFilter(layout, filter) }]
  )
